export const basecampArticle = {
  "title": "What using Basecamp with an agent made us think about Rill",
  "slug": "using-basecamp-with-an-agent",
  "date": "2026-10-14",
  "description": "How we used Basecamp and Codex to organize Rill’s backlog, and what working alongside an agent made us think about recording, review, and collaboration."
} as const;
